module.exports = __webpack_public_path__ + "static/media/EmployeeSelectionBlue.4654b1b8.svg";